const footerQrcodeConfig = [
  {
    key: "video",
    labelKey: "contact.video",
    visibleHosts: ["www", "app", "jiyuai", "akpnai"],
    images: {
      default: () => require("../assets/images/ai-img-video.jpg"),
      jiyuai: () => require("../assets/logo/jiyuai/img-video.png"),
      akpnai: () => require("../assets/logo/akpnai/img-video.png"),
    },
  },
  {
    key: "douyin",
    labelKey: "contact.douyin",
    visibleHosts: ["imouse", "eweadn", "dario", "jiyuai"],
    images: {
      default: () => require("../assets/images/ai-img-douyin-bg.png"),
      imouse: () => require("../assets/logo/cleverAI/img-douyin.png"),
      jiyuai: () => require("../assets/logo/jiyuai/img-douyin.png"),
    },
  },
  {
    key: "wechat-account",
    labelKey: "contact.weChatAccount",
    visibleHosts: [
      "www",
      "app",
      "imouse",
      "eweadn",
      "dario",
      "taiguo",
      "akpnai",
      "baseus",
    ],
    images: {
      default: () => require("../assets/images/ai-img-qcode.png"),
      imouse: () => require("../assets/logo/cleverAI/img-qcode.png"),
      dido: () => require("../assets/logo/dido/img-qcode.png"),
      taiguo: () => require("../assets/logo/taiguo/img-qcode.png"),
      akpnai: () => require("../assets/logo/akpnai/img-qcode.png"),
      baseus: () => require("../assets/code/baseus/code.png"),
    },
  },
  {
    key: "customer-service",
    labelKey: "contact.customerService",
    visibleHosts: ["www", "app", "imouse", "eweadn", "dario", "akpnai"],
    images: {
      default: () => require("../assets/images/ai-img-service.png"),
      imouse: () => require("../assets/logo/cleverAI/img-service.png"),
      akpnai: () => require("../assets/logo/akpnai/img-service.png"),
    },
  },
  {
    key: "business",
    labelKey: "contact.business",
    visibleHosts: ["jiyuai"],
    images: {
      jiyuai: () => require("../assets/logo/jiyuai/img-service.png"),
    },
  },
];

export default footerQrcodeConfig;
